/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TreatmentRegimen from './treatment-regimen';
import TreatmentRegimenDetail from './treatment-regimen-detail';
import TreatmentRegimenUpdate from './treatment-regimen-update';
import TreatmentRegimenDeleteDialog from './treatment-regimen-delete-dialog';

const TreatmentRegimenRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TreatmentRegimen />} />
    <Route path="new" element={<TreatmentRegimenUpdate />} />
    <Route path=":id">
      <Route index element={<TreatmentRegimenDetail />} />
      <Route path="edit" element={<TreatmentRegimenUpdate />} />
      <Route path="delete" element={<TreatmentRegimenDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TreatmentRegimenRoutes;
